import { styled } from "@mui/material/styles";
import { Box, BoxProps } from "@mui/material";

import { TnC } from "../TnC";
import { ReportErrorLink } from "../ReportErrorLink";


interface FooterWrapperProps extends BoxProps {
  marginBottom?: string | number;
}

const FooterWrapper = styled(
    Box,
    { shouldForwardProp: prop => prop !== "marginBottom" }
)<FooterWrapperProps>(
    ({ marginBottom }) => ({
        width: "100%",

        paddingTop: 60,

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",

        paddingBottom: marginBottom,
    })
);

interface FooterProps {
    showCheckbox?: boolean,
    marginBottom?: FooterWrapperProps["marginBottom"],
    tncChecked?: boolean,
    setTncChecked?: (value: boolean) => void,
}

export const Footer: React.FC<FooterProps> = props => {
    const {
        showCheckbox,
        marginBottom=30,
        tncChecked,
        setTncChecked,
    } = props;

    return (
        <FooterWrapper marginBottom={marginBottom}>
            <TnC
                showCheckbox={showCheckbox}
                tncChecked={tncChecked}
                setTncChecked={setTncChecked}
            />
            <ReportErrorLink />
        </FooterWrapper>
    );
};
